import type { Platform, TrackEventName, TrackEventPayload } from "../types";
import { getOrCreateVisitorId } from "../visitor-id";
import { sendEvent } from "./sender";

export interface Tracker {
  track(name: TrackEventName, data?: Record<string, unknown>): void;
}

export function createTracker(apiBase: string, publicKey: string, platform: Platform): Tracker {
  // Resolvido uma vez por carregamento (não a cada .track()) — leitura/escrita
  // de storage é idempotente, mas não há motivo pra repetir a cada evento.
  const visitorId = getOrCreateVisitorId() ?? undefined;

  return {
    track(name, data) {
      const payload: TrackEventPayload = {
        name,
        url: window.location.href,
        platform,
        data,
        visitorId,
      };
      sendEvent(apiBase, publicKey, payload);
    },
  };
}

export function bindClickTracking(tracker: Tracker): void {
  document.addEventListener(
    "click",
    (event) => {
      const target = (event.target as Element | null)?.closest<HTMLElement>(
        "[data-indexaai-track]",
      );
      if (!target) return;

      tracker.track("click", { trackId: target.dataset.indexaaiTrack });
    },
    { capture: true },
  );
}
